import {
  FormattedDurationOptions,
  formatDateRelative,
  formattedDuration,
  replaceWithTodayAndTomorrow,
} from 'ui-format-utils';
import { BasicStoreFragment } from 'drycut-graphql';
import { useStoreWaitingTimeCountDown } from './useStoreWaitingTimeCountDown';

type Props = {
  store: BasicStoreFragment;
} & FormattedDurationOptions;

export function StoreWaitingTime({ store, ...options }: Props): JSX.Element {
  const time = useStoreWaitingTimeCountDown({ store });

  if (store?.openNow || !store?.nextOpenAt) {
    return <span data-time={time}>{formattedDuration(time, options)}</span>;
  }

  return (
    <span data-time={time}>
      {formatDateRelative({
        value: store?.nextOpenAt,
        offsetSeconds: time,
        replace: replaceWithTodayAndTomorrow,
      })}
    </span>
  );
}
